(function () {
  function headerFor(element) {
    return element && element.closest
      ? element.closest(".relenser-site-header")
      : document.querySelector(".relenser-site-header");
  }

  window.toggleRelenserMenu = function (button) {
    var header = headerFor(button);
    var menu = header && header.querySelector("#RelenserMobileMenu");
    if (!menu) return;
    var open = menu.classList.toggle("open");
    button.setAttribute("aria-expanded", open ? "true" : "false");
  };

  window.closeRelenserMenu = function () {
    var header = document.querySelector(".relenser-site-header");
    if (!header) return;
    var menu = header.querySelector("#RelenserMobileMenu");
    var button = header.querySelector(".hamburger");
    if (menu) menu.classList.remove("open");
    if (button) button.setAttribute("aria-expanded", "false");
  };

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") window.closeRelenserMenu();
  });

  // Footer "Cookie settings": reopen Shopify's own consent dialog. Opening it
  // does not change consent; only the buyer's choice in the dialog does.
  function showCookiePreferences() {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === "function") {
      window.privacyBanner.showPreferences();
      return true;
    }
    return false;
  }

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest && event.target.closest("[data-relenser-cookie-preferences]");
    if (!trigger) return;
    event.preventDefault();
    if (showCookiePreferences()) return;
    if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      trigger.setAttribute("aria-busy", "true");
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function () {
        trigger.removeAttribute("aria-busy");
        showCookiePreferences();
      });
    }
  });
})();
